import { Alert, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch } from 'src/redux/store';
import PageHeader from 'src/components/display/PageHeader';
import { useEffect, useState } from 'react';
import { SSA3DViewer } from '@surface-solutions/ssa-3d-viewer';
import { ModelStats } from '@surface-solutions/ssa-3d-viewer/dist/context/ViewerContext';
import { FileResource } from 'src/backend/market';
import { loadFile } from 'src/redux/thunks/fileManager.thunk';
import i18n from 'src/i18n/i18n';
import { connect } from 'react-redux';
import useDialog from 'src/hooks/useDialog';
import { useNavigate } from 'react-router';
import { nav } from 'src/statics/navigations';
import { startUserLockChecker, stopUserLockChecker } from 'src/redux/thunks/user.thunk';
import { getProCalc, updateItemWithFile } from 'src/redux/thunks/proCalc.thunk';
import { CalculationResource, ItemResource } from 'src/backend/coreCalc';

interface Props {}

const AutoAnalyze3d: React.FC<Props> = ({}) => {
    const navigate = useNavigate();
    const [calc, setCalc] = useState<CalculationResource>();
    const [isSuccess, setSuccess] = useState<boolean>(false);
    const [file, setFile] = useState<FileResource>();
    const [item, setItem] = useState<ItemResource>();
    const dispatch = useDispatch();
    const dialog = useDialog();
    const { t } = useTranslation();
    const theme = useTheme();

    const errorDialogSettings = {
        severity: 'error' as any,
        okText: t('toDashboard'),
        showCancel: false,
        disableClickAway: true,
        component: <Typography>{t('fileOrCalcNotFoundExplanation')}</Typography>,
        title: t('fileOrCalcNotFoundTitle'),
        okCallback: () => {
            dialog.closeDialog();
            navigate(nav.DASHBOARD.path);
        }
    };

    useEffect(() => {
        dispatch(stopUserLockChecker());
        const queryParams = new URLSearchParams(location.search);
        const nodeId = queryParams.get('nodeId');
        const calculationId = queryParams.get('calculationId');
        if (!nodeId || !calculationId) {
            return dialog.openDialog(errorDialogSettings);
        }

        loadFileResource(nodeId);

        dispatch(getProCalc(calculationId)).then((calc) => {
            setCalc(calc);
            const found = (calc?.items || []).find((item) => item.threeDFileId === nodeId);
            if (found) setItem(found);
            else dialog.openDialog(errorDialogSettings);
        });

        return () => {
            dispatch(startUserLockChecker());
        };
    }, []);

    const loadFileResource = async (nodeId: string) => {
        const file: FileResource = await dispatch(loadFile(nodeId));
        if (file) setFile(file);
        else dialog.openDialog(errorDialogSettings);
    };

    const handleOnViewerLoader = async (modelStats: ModelStats) => {
        if (!modelStats || !item) return;
        setSuccess(false);

        await dispatch(updateItemWithFile(calc, { item, fileResource: file, modelStats }));

        setSuccess(true);
    };

    return (
        <>
            <PageHeader>{isSuccess && <Alert id="success-alert">{t('successfullySavedModelDataToCalc')}</Alert>}</PageHeader>
            <Stack direction="row" mx={{ xs: -2, md: -4 }} mt={{ xs: -1.5, md: 0 }} mb={-4} flexGrow={1} overflow="hidden">
                {file && item && <SSA3DViewer url={file.url} fileName={file.name} language={i18n.language} onViewerLoaded={handleOnViewerLoader} />}
            </Stack>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};
export default connect(mapStateToProps)(AutoAnalyze3d);
